import React from "react";
import Box from "@mui/material/Box";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import CampaignApproval from "./CampaignApproval";
import PointBudgetApproval from "./PointBudgetApproval";



export default function IncentiveRowManagement(props) {

     const [tabValue, setTabValue] = React.useState(0);

     const tabHandleChange = (event, newValue) => {
          setTabValue(newValue);
     };


     function TabPanel(props) {
          const { children, tabValue, index, ...other } = props;

          return (
               <div
                    role="tabpanel"
                    hidden={tabValue !== index}
                    id={`full-width-tabpanel-${index}`}
                    aria-labelledby={`full-width-tab-${index}`}
                    {...other}
               >
                    {tabValue === index && <Box sx={{ p: 3 }}>{children}</Box>}
               </div>
          );
     }


     return (
          <>
               <div className="sba-tab-container">
                    <Tabs
                         onChange={tabHandleChange}
                         value={tabValue}
                         selectionFollowsFocus
                         sx={{ mt: 1 }}
                    >
                         <Tab label="Campaign Approval"></Tab>
                         <Tab label="Points Budget Approval"></Tab>
                    </Tabs>
                    <TabPanel
                         tabValue={tabValue}
                         index={0}
                         className="sba-tab-panel"
                    >
                         <CampaignApproval />
                    </TabPanel>
                    <TabPanel
                         tabValue={tabValue}
                         index={1}
                         className="sba-tab-panel"
                    >
                         <PointBudgetApproval />
                    </TabPanel>

               </div>
          </>
     );
}
